import { render } from "./FavouritesView.vue?vue&type=template&id=78ab0dc6&scoped=true"
import script from "./FavouritesView.vue?vue&type=script&lang=js"
export * from "./FavouritesView.vue?vue&type=script&lang=js"

import "./FavouritesView.vue?vue&type=style&index=0&id=78ab0dc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ab0dc6"]])

export default __exports__